import { VhcRecordForm } from './forms/vhc-record';
import { useWaitingStore } from './forms/vhc-record/waiting-context';
import styles from './styles.module.scss';
import { useVhcRecordModal } from './useVhcRecordModal';
import { useVhcRecordStoreStore } from './vhc-record.store';
import { useIsInIframe } from 'features/vhc/hooks/use-is-in-Iframe';
import { useEffect } from 'react';
import { Modal } from 'react-bootstrap';

export const VhcRecordModal = () => {
  const resetWaiting = useWaitingStore((x) => x.resetWaiting);
  const setState = useVhcRecordStoreStore((x) => x.setState);

  const isInIframe = useIsInIframe();
  const { recordModalIsOpen, recordFormState, handleClose, groupName } = useVhcRecordModal();

  const description = recordFormState?.watch('description');

  useEffect(() => {
    return () => {
      resetWaiting();
      setState();
    };
  }, []);
  return (
    <Modal
      show={recordModalIsOpen}
      onHide={handleClose}
      centered
      keyboard={true}
      size="lg"
      dialogClassName="modal-custom-width"
      className={isInIframe ? styles.maxWidthModal : ''}
    >
      <Modal.Header className="p-10 pb-8 fs-2 fw-bold text-gray-700" closeButton>
        <Modal.Title>
          {groupName} - {description}
        </Modal.Title>
      </Modal.Header>
      <div className="px-10 pt-5 pb-10">
        <VhcRecordForm handleClose={handleClose} formData={recordFormState} />
      </div>
    </Modal>
  );
};
